export const getClientInitials = (nome, cognome) => {
  const first = nome?.trim()?.charAt(0)?.toUpperCase() || '';
  const last = cognome?.trim()?.charAt(0)?.toUpperCase() || '';
  if (first && last) return `${first}.${last}.`;
  if (first) return `${first}.`;
  if (last) return `${last}.`;
  return '';
};

export const isCalendarBreak = (task) => {
  if (!task || task.limitCard) return false;
  if (task.isBreak === 1 || task.isBreak === true || task.isBreak === '1') return true;
  const name = String(task.nome || '').trim().toUpperCase();
  const note = String(task.nota || '').trim().toUpperCase();
  return name === 'PAUSA' || note === 'PAUSA';
};

export const getClientDisplayName = (task) => {
  const note = String(task?.nota || '').trim();
  const firstName = String(task?.nome || '').trim();
  const lastName = String(task?.cognome || '').trim();

  // Prenotazione senza anagrafica completa dove la nota è usata come nome in card.
  // Dopo l'edit il BE può aggiornare solo `nota`: preferiamo quella.
  const noteUsedAsName =
    note &&
    !lastName &&
    (Boolean(task?.selfPrenotazione) || !firstName || firstName === note);

  if (noteUsedAsName) return note;

  if (firstName) {
    return `${firstName}${lastName ? ` ${lastName}` : ''}`.trim();
  }
  if (note) return note;
  if (task?.self_prenotatione || task?.selfPrenotazione) return 'Da salone';
  return `Utente ${task?.idutente ?? task?.utente ?? ''}`.trim();
};

export const getPrimaryServiceName = (servizi = []) => {
  if (!servizi.length) return '';
  return servizi.map((service) => service.nome).filter(Boolean).join(', ');
};

export const getSplitCardLayout = (overlapIndex, maxColumns = 2) => {
  const columns = Math.max(1, Math.min(maxColumns, 2));
  const gapPercent = 2;
  const widthPercent = (100 - gapPercent * (columns + 1)) / columns;
  const leftPercent = gapPercent + overlapIndex * (widthPercent + gapPercent);

  return {
    left: `${leftPercent}%`,
    width: `${widthPercent}%`,
  };
};
